module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.getBlockModifiers()
  }, [((_vm.data.header1 || _vm.data.header2 || _vm.data.header3) && _vm.isMobile && _vm.data.mobileHeaderTop) ? _c('div', {
    class: [_vm.block + '-header', {
      'm-large': _vm.data.headerSize === 'large'
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.data.header1 || _vm.data.header2 || _vm.data.header3)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showColumn1) ? _c('div', {
    class: [_vm.block + '-column', {
      'm-shrink': _vm.shrinkColumn1 || _vm.growColumn2
    }]
  }, [(_vm.data.component1) ? _c(_vm.data.component1.type, {
    tag: "component",
    attrs: {
      "data": _vm.data.component1.data
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.link1 && _vm.data.link1.route && _vm.data.linkAll && !_vm.data.link1.externalLink) ? _c('router-link', {
    class: [_vm.block + '-columnContent'],
    attrs: {
      "to": '/' + _vm.data.link1.route
    }
  }, [(_vm.data.img1) ? _c('ImageBlock', {
    class: [_vm.block + '-image'],
    attrs: {
      "data": _vm.data.img1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.header1 && !(_vm.isMobile && _vm.data.mobileHeaderTop)) ? _c('div', {
    class: [_vm.block + '-header', {
      'm-large': _vm.data.headerSize === 'large'
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.data.header1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.text1) ? _c('div', {
    class: [_vm.block + '-text'],
    domProps: {
      "innerHTML": _vm._s(_vm.data.text1)
    }
  }) : _vm._e()], 1) : (_vm.data.link1 && _vm.data.linkAll && _vm.data.link1.externalLink) ? _c('a', {
    class: [_vm.block + '-columnContent'],
    attrs: {
      "href": _vm.data.link1.externalLink
    }
  }, [(_vm.data.img1) ? _c('ImageBlock', {
    class: [_vm.block + '-image'],
    attrs: {
      "data": _vm.data.img1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.header1 && !(_vm.isMobile && _vm.data.mobileHeaderTop)) ? _c('div', {
    class: [_vm.block + '-header', {
      'm-large': _vm.data.headerSize === 'large'
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.data.header1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.text1) ? _c('div', {
    class: [_vm.block + '-text'],
    domProps: {
      "innerHTML": _vm._s(_vm.data.text1)
    }
  }) : _vm._e()], 1) : _c('div', {
    class: [_vm.block + '-columnContent']
  }, [(_vm.data.img1) ? _c('ImageBlock', {
    class: [_vm.block + '-image'],
    attrs: {
      "data": _vm.data.img1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.header1 && !(_vm.isMobile && _vm.data.mobileHeaderTop)) ? _c('div', {
    class: [_vm.block + '-header', {
      'm-large': _vm.data.headerSize === 'large'
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.data.header1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.text1) ? _c('div', {
    class: [_vm.block + '-text'],
    domProps: {
      "innerHTML": _vm._s(_vm.data.text1)
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.data.link1) ? _c('TextLink', {
    class: [_vm.block + '-link'],
    attrs: {
      "data": _vm.data.link1
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showColumn2) ? _c('div', {
    class: [_vm.block + '-column', {
      'm-hide': _vm.growColumn1
    }]
  }, [(_vm.data.component2) ? _c(_vm.data.component2.type, {
    tag: "component",
    class: {
      'bm-noMargin': _vm.data.columns === 3
    },
    attrs: {
      "data": _vm.data.component2.data
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.link2 && _vm.data.link2.route && _vm.data.linkAll && !_vm.data.link2.externalLink) ? _c('router-link', {
    class: [_vm.block + '-columnContent'],
    attrs: {
      "to": '/' + _vm.data.link2.route
    }
  }, [(_vm.data.img2) ? _c('ImageBlock', {
    class: [_vm.block + '-image'],
    attrs: {
      "data": _vm.data.img2
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.header2 && !(_vm.isMobile && _vm.data.mobileHeaderTop)) ? _c('div', {
    class: [_vm.block + '-header', {
      'm-large': (_vm.data.headerSize === 'large' && _vm.data.columns == 3)
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.data.header2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.text2) ? _c('div', {
    class: [_vm.block + '-text'],
    domProps: {
      "innerHTML": _vm._s(_vm.data.text2)
    }
  }) : _vm._e()], 1) : (_vm.data.link2 && _vm.data.linkAll && _vm.data.link2.externalLink) ? _c('a', {
    class: [_vm.block + '-columnContent'],
    attrs: {
      "href": _vm.data.link2.externalLink
    }
  }, [(_vm.data.img2) ? _c('ImageBlock', {
    class: [_vm.block + '-image'],
    attrs: {
      "data": _vm.data.img2
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.header2 && !(_vm.isMobile && _vm.data.mobileHeaderTop)) ? _c('div', {
    class: [_vm.block + '-header', {
      'm-large': (_vm.data.headerSize === 'large' && _vm.data.columns == 3)
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.data.header2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.text2) ? _c('div', {
    class: [_vm.block + '-text'],
    domProps: {
      "innerHTML": _vm._s(_vm.data.text2)
    }
  }) : _vm._e()], 1) : _c('div', {
    class: [_vm.block + '-columnContent']
  }, [(_vm.data.img2) ? _c('ImageBlock', {
    class: [_vm.block + '-image'],
    attrs: {
      "data": _vm.data.img2
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.header2 && !(_vm.isMobile && _vm.data.mobileHeaderTop)) ? _c('div', {
    class: [_vm.block + '-header', {
      'm-large': (_vm.data.headerSize === 'large' && _vm.data.columns == 3)
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.data.header2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.text2) ? _c('div', {
    class: [_vm.block + '-text'],
    domProps: {
      "innerHTML": _vm._s(_vm.data.text2)
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.data.link2) ? _c('TextLink', {
    class: [_vm.block + '-link'],
    attrs: {
      "data": _vm.data.link2
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showColumn3) ? _c('div', {
    class: [_vm.block + '-column', {
      'm-shrink': _vm.shrinkColumn3 || _vm.growColumn1 || _vm.growColumn2
    }]
  }, [(_vm.data.component3) ? _c(_vm.data.component3.type, {
    tag: "component",
    attrs: {
      "data": _vm.data.component3.data
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.link3 && _vm.data.link3.route && _vm.data.linkAll && !_vm.data.link3.externalLink) ? _c('router-link', {
    class: [_vm.block + '-columnContent'],
    attrs: {
      "to": '/' + _vm.data.link3.route
    }
  }, [(_vm.data.img3) ? _c('ImageBlock', {
    class: [_vm.block + '-image'],
    attrs: {
      "data": _vm.data.img3
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.header3 && !(_vm.isMobile && _vm.data.mobileHeaderTop)) ? _c('div', {
    class: [_vm.block + '-header', {
      'm-large': _vm.data.headerSize === 'large'
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.data.header3)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.text3) ? _c('div', {
    class: [_vm.block + '-text'],
    domProps: {
      "innerHTML": _vm._s(_vm.data.text3)
    }
  }) : _vm._e()], 1) : (_vm.data.link3 && _vm.data.linkAll && _vm.data.link3.externalLink) ? _c('a', {
    class: [_vm.block + '-columnContent'],
    attrs: {
      "href": _vm.data.link3.externalLink
    }
  }, [(_vm.data.img3) ? _c('ImageBlock', {
    class: [_vm.block + '-image'],
    attrs: {
      "data": _vm.data.img3
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.header3 && !(_vm.isMobile && _vm.data.mobileHeaderTop)) ? _c('div', {
    class: [_vm.block + '-header', {
      'm-large': _vm.data.headerSize === 'large'
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.data.header3)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.text3) ? _c('div', {
    class: [_vm.block + '-text'],
    domProps: {
      "innerHTML": _vm._s(_vm.data.text3)
    }
  }) : _vm._e()], 1) : _c('div', {
    class: [_vm.block + '-columnContent']
  }, [(_vm.data.img3) ? _c('ImageBlock', {
    class: [_vm.block + '-image'],
    attrs: {
      "data": _vm.data.img3
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.header3 && !(_vm.isMobile && _vm.data.mobileHeaderTop)) ? _c('div', {
    class: [_vm.block + '-header', {
      'm-large': _vm.data.headerSize === 'large'
    }],
    domProps: {
      "innerHTML": _vm._s(_vm.data.header3)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.data.text3) ? _c('div', {
    class: [_vm.block + '-text'],
    domProps: {
      "innerHTML": _vm._s(_vm.data.text3)
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.data.link3) ? _c('TextLink', {
    class: [_vm.block + '-link'],
    attrs: {
      "data": _vm.data.link3
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c197f7e","buble":{"objectAssign":"Object.assign"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/globalBlocks/FlexBlock.vue
// module id = 604
// module chunks = 0